import type { ReactElement } from 'react';
import { cn } from '@/shared/ui';
import { STORE_EXHIBITION_BANNER_FRAME } from './store-exhibition-banner-frame';

/**
 * 기획전 이름을 받는 동안 띠 자리를 지키는 회색 칸 — 문구 없이 채워지는 중(aria-busy)만 알린다.
 * 띠와 같은 바깥 틀을 써서 이름이 도착해 띠로 바뀌어도 아래 목록이 밀리지 않는다.
 */
export const StoreExhibitionBannerPlaceholder = (): ReactElement => (
  <div role="status" aria-busy="true" className={cn(STORE_EXHIBITION_BANNER_FRAME, 'bg-muted')}>
    {/* 띠 제목 한 줄(text-sm, 줄 높이 1.25rem)과 같은 높이 — 바깥 크기를 띠와 맞춘다. */}
    <div className="h-5" />
  </div>
);
